export default (initialOpen = false, baseUrl = "") => ({
  modalOpen: initialOpen,
  baseUrl,
  basePath: "",
  activeEvent: "",

  init() {
    if (this.baseUrl) {
      try {
        this.basePath = new URL(this.baseUrl).pathname;
      } catch (e) {
        this.basePath = this.baseUrl;
      }
    }

    htmx.config.historyCacheSize = 0;
    htmx.config.historyEnabled = false;

    window.addEventListener("popstate", () => this.handleUrlChange());

    const currentPath = window.location.pathname;
    if (
      currentPath !== this.basePath &&
      currentPath.startsWith(this.basePath + "/")
    ) {
      this.handleUrlChange();
    }

    this.$nextTick(() => {
      if (this.$refs.agendaMenu) {
        this.$refs.agendaMenu.scrollLeft =
          parseInt(sessionStorage.getItem("agendaMenu")) || 0;
      }
    });
  },

  loadEvent(url) {
    if (this.modalOpen) return;
    this.activeEvent = url;
    history.pushState({}, "", url);
    const slug = new URL(url).pathname.replace(this.basePath + "/", "");
    this.fetchEvent(slug);
  },

  fetchEvent(slug) {
    if (this.modalOpen) return;
    this.modalOpen = true;

    this.$nextTick(() => {
      if (
        this.$refs.modalContent &&
        !this.$refs.modalContent.innerHTML.trim()
      ) {
        const fetchUrl = `${this.baseUrl}?ajax=modal&event=${slug}`;
        fetch(fetchUrl)
          .then((response) => response.text())
          .then((html) => (this.$refs.modalContent.innerHTML = html));
      }
    });
  },

  handleUrlChange() {
    const currentPath = window.location.pathname;
    const isEventUrl =
      currentPath !== this.basePath &&
      currentPath.startsWith(this.basePath + "/");

    if (isEventUrl) {
      const slug = currentPath.replace(this.basePath + "/", "").split("?")[0];
      this.fetchEvent(slug);
    } else if (this.modalOpen) {
      this.clearModal();
    }
  },

  clearModal() {
    this.modalOpen = false;
    this.activeEvent = "";
    if (this.$refs.modalContent) {
      this.$refs.modalContent.innerHTML = "";
    }
  },

  closeModal() {
    this.clearModal();
    history.pushState({}, "", this.baseUrl);
  },

  openFilter(filter) {
    window.location.href = `${this.basePath}?category=${filter}`;
  },

  resetFilters() {
    window.location.href = this.basePath;
  },

  openArchive() {
    window.location.href = `${this.basePath}?view=archive`;
  },

  saveTagsScroll() {
    sessionStorage.setItem("agendaMenu", this.$refs.agendaMenu.scrollLeft);
  },
});
